import type {Key} from '@react-types/shared';
import {
  type ButtonSize,
  type IconName,
  ToggleButtonGroup,
} from '@wandb/components';
import {type LayoutType} from '@wandb/weave/common/types/media';
import React, {useCallback} from 'react';

const BUTTON_VALUE_TO_LAYOUT: {[key: string]: LayoutType} = {
  Overlay: 'ALL_STACKED',
  Split: 'MASKS_NEXT_TO_IMAGE',
  Spread: 'ALL_SPLIT',
};
const BUTTON_VALUE_TO_ICON: {[key: string]: IconName} = {
  Overlay: 'versions-layers',
  Split: 'split',
  Spread: 'layout-grid',
};
const LAYOUT_TOGGLE_ITEMS = Object.entries(BUTTON_VALUE_TO_ICON).map(
  ([key, icon]) => ({
    id: key,
    children: key,
    icon,
    'data-test': `toggle-button-${key}`,
  })
);

export const MaskControlsLayout = ({
  mediaKey,
  maskLayout,
  onChangeMaskLayout,
  size = 'sm',
}: {
  mediaKey: string;
  maskLayout: LayoutType;
  onChangeMaskLayout: (mediaKey: string, layoutType: LayoutType) => void;
  size?: ButtonSize;
}) => {
  const selectedLayout =
    Object.entries(BUTTON_VALUE_TO_LAYOUT).find(
      ([_, value]) => value === maskLayout
    )?.[0] ?? 'Overlay';

  const onToggleSelection = useCallback(
    (keys: Set<Key>) => {
      const layoutType = BUTTON_VALUE_TO_LAYOUT[String(Array.from(keys)[0])];
      if (layoutType) {
        onChangeMaskLayout(mediaKey, layoutType);
      }
    },
    [mediaKey, onChangeMaskLayout]
  );

  return (
    <ToggleButtonGroup
      aria-label="Mask layout"
      items={LAYOUT_TOGGLE_ITEMS}
      selectedKeys={[selectedLayout]}
      selectionMode="single"
      disallowEmptySelection
      size={size}
      onSelectionChange={onToggleSelection}
    />
  );
};
